angular.module('env.localStorage', [])

    .provider('$localStorage', function (omLoggerProvider) {
        var $log = omLoggerProvider;
        var localStorage = window && window.localStorage ? window.localStorage : null;
        var uniquePrefix = "om" + hashCode(getBaseUrl()) + "_";

        var _this = this;

        function getBaseUrl() {
            var href = '';
            href += window.location.protocol + '//' + window.location.hostname;
            var port = window.location.port;
            if (port && port.length > 0) {
                href += ':' + port;
            }
            href += window.location.pathname;
            return href.toLowerCase();
        }

        function hashCode(string) {
            var hash = 0, i, chr, len;
            if (string.length == 0) return hash;
            for (i = 0, len = string.length; i < len; i++) {
                chr = string.charCodeAt(i);
                hash = ((hash << 5) - hash) + chr;
                hash |= 0; // Convert to 32bit integer
            }
            return hash;
        }

        //region Public methods

        /**
         * Gets item from localStorage by its key. If there is no such key - return NULL.
         */
        function getItem(key) {
            var value;

            if (localStorage) {
                try {
                    value = angular.fromJson(localStorage.getItem(uniquePrefix + key));
                } catch (e) {
                    $log.error("Exception during LocalStorage access!", e);
                }
            } else {
                $log.warn("Browser does not support LocalStor" +
                    "age feature! Returning nothing from LocalStorage.");
            }

            return value;
        }

        /**
         * Sets item into localStorage by its key. Item will be rewritten, if there is value with such key already.
         */
        function setItem(key, value) {
            if (localStorage) {
                try {
                    localStorage.setItem(uniquePrefix + key, angular.toJson(value));
                } catch (e) {
                    $log.error("Exception during LocalStorage access!", e);
                }
            } else {
                $log.warn("Browser does not support LocalStorage feature! Setting nothing into LocalStorage.");
            }
        }

        /**
         * Remove localStorage item by its key.
         */
        function removeItem(key) {
            if (localStorage) {
                try {
                    localStorage.removeItem(uniquePrefix + key);
                } catch (e) {
                    $log.error("Exception during LocalStorage access!", e);
                }
            } else {
                $log.warn("Browser does not support LocalStorage feature! Removing nothing from LocalStorage.");
            }
        }

        _.extend(_this, {
            getItem: getItem,
            setItem: setItem,
            removeItem: removeItem
        });

        //endregion

        this.$get = function () {
            return {
                getItem: getItem,
                setItem: setItem,
                removeItem: removeItem
            };
        };
    })

;